import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useActiveFilters() {
    return useAppSelector((state) => state.filter)
}